import uuidv4 from 'uuid/v4'

class Snippets {
    static _snippetsKey = "snippets"
    static _listeners = {}

    static store(text) {
        var key
        const list = Snippets.getList()
        var duplicated = false
        for(var entry of list) {
            if (entry.text === text) {
                entry.at = new Date().getTime()
                duplicated = true
                key = entry.key
            }
        }
        if (duplicated) {
            list.sort((a, b) => {
                return a.at - b.at
            })
        }
        else {
            key = uuidv4()
            list.push({
                at: new Date().getTime(),
                key: key,
                text: text,
            })
            if (list.length > 5) {
                list.shift()
            }
        }
        Snippets._storeInStorage(list)
        return key
    }

    static getList() {
        try {
            const list = JSON.parse(localStorage.getItem(Snippets._snippetsKey))
            if (list) {
                return list
            }
        }
        catch(e) {}
        return []
    }

    static isEmpty() {
        return Snippets.getList().length <= 0
    }

    static retrieve(key) {
        for(const obj of Snippets.getList()) {
            if (obj.key === key) {
                return obj
            }
        }
        return null
    }

    static remove(key) {
        const list = Snippets.getList()
        for(var idx=0; idx<list.length; idx++) {
            if (list[idx].key === key) {
                const removed = list.splice(idx, 1)
                Snippets._storeInStorage(list)
                return removed[0]
            }
        }
        return null
    }

    static subscribe(listener) {
        const subscriptionToken = uuidv4()
        Snippets._listeners[subscriptionToken] = listener
        return subscriptionToken
    }

    static unsubscribe(subscriptionToken) {
        delete Snippets._listeners[subscriptionToken]
    }

    static resetAll() {
        localStorage.removeItem(Snippets._snippetsKey)
    }

    static _storeInStorage(arr) {
        localStorage.setItem(Snippets._snippetsKey, JSON.stringify(arr))

        window.setTimeout(() => {
            Object.keys(Snippets._listeners).forEach(subscriptionToken => {
                const func = Snippets._listeners[subscriptionToken]
                try {
                    func(subscriptionToken)
                }
                catch(e) { /* ignore */ }
            })
        })
    }
}

export default Snippets
